import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// material-ui icons
import OrderIco from '@material-ui/icons/ChangeHistory';
// material-ui/ core components
import orderStyle from 'assets/jss/AdsOrder';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import Button from 'components/UI/CustomButtons/Button';

/**
 * @description
 * Constant to map order selectors.
 * @param {Function} translation - Passed from HOC.
 * @returns {Array} - With the translated order selectors.
 */
const orderSelectors = translation => [
  { field: 'ID', val: 'id', column: 'title' },
  {
    field: translation('ad.order.subcat'),
    val: 'subcategory',
    column: 'title',
  },
  { field: translation('ad.order.status'), val: 'status', column: 'public' },
  {
    field: translation('ad.order.reviewed'),
    val: 'reviewed',
    column: 'review',
  },
  {
    field: translation('ad.order.date'),
    val: 'updated_on',
    column: 'title',
  },
  {
    field: translation('ad.order.reported'),
    val: 'flag_count',
    column: 'title',
  },
  {
    field: translation('ad.order.reported_date'),
    val: 'last_flagged_on',
    column: 'title',
  },
];

/**
 * @description
 * Stateless component
 *
 * @param {Object} props - Props from parent.
 */
const AdOrder = props => {
  const { classes, appliedOrder, changeOrder, t } = props;
  return (
    <React.Fragment>
      <h6>{t('ad.order.title')}</h6>
      <div className={classes.container}>
        <div className={classes.buttonGroup}>
          {orderSelectors(t).map(f => (
            <Button
              data-cy={`order-btn-${f.val}`}
              simple={f.val !== appliedOrder.orderField}
              onClick={() => changeOrder(f)}
              color="info"
              round
              className={classes.orderBtn}
              key={`order-btn-${f.val}`}
            >
              {f.field}
              {f.val === appliedOrder.orderField && (
                <OrderIco
                  className={`${classes.orderIco} ${!appliedOrder.orderAsc &&
                    classes.rotateIco}`}
                />
              )}
            </Button>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

/**
 * Order PropTypes
 * @param classes - styles
 * @param appliedOrder - current applied order
 * @param t - prop from HOC with string translations
 * @callback changeOrder - callback to change order type
 */
AdOrder.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  appliedOrder: PropTypes.shape({}).isRequired,
  changeOrder: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(orderStyle)(AdOrder));
